import { Stack } from "@mui/material";
import AgentInboxChannelsSection from "./AgentInboxChannelsSection";
import GeneralAgentInboxSettingsSection from "./GeneralAgentInboxSettingsSection";

const AgentInboxSettingsContainer = () => {
  return (
    <Stack spacing={4}>
      <GeneralAgentInboxSettingsSection />
      <AgentInboxChannelsSection />
    </Stack>
  );
};

export default AgentInboxSettingsContainer;
